import Vue from 'vue';
import _ from 'lodash';

export default {
  data() {
    return {
      statuses: [
        {
          text: 'Activa',
          value: 1,
        },
        {
          text: 'En proceso',
          value: 2,
        },
        {
          text: 'Pausada',
          value: 3,
        },
        {
          text: 'Finalizada',
          value: 4,
        },
      ],
    };
  },
  methods: {
    call_icon(status) {
      let icon = 'fas fa-check';
      if (status === 2) {
        icon = 'far fa-clock';
      } else if (status === 3) {
        icon = 'fas fa-pause';
      } else if (status === 4) {
        icon = 'far fa-bookmark';
      }
      return icon;
    },
    call_color(status) {
      let color = 'green darken-3';
      if (status === 2) {
        color = 'blue darken-3';
      } else if (status === 3) {
        color = 'cyan lighten-2';
      } else if (status === 4) {
        color = 'red darken-3';
      }
      return color;
    },
    updateStatus(status, call) {
      if (call.type_id !== 3) {
        const kpi = _.find(JSON.parse(call.order), 'avoid_last_kpi') || {};
        const obj = { ...call, status };
        obj.avoid_last_kpi = kpi.avoid_last_kpi || false;
        this.axios.patch(`calls_lists/${obj.id}`, {
          ...obj,
        }).then(() => {
          this.update(obj);
        }).catch(() => {});
      }
    },
    call_name(status) {
      return (_.find(this.statuses, (x => x.value === status)) || {}).text;
    },
    getSqsList(data) {
      return Vue.axios.get(`/call_center/queues?call_list_id=${data.call_list_id}&only_programmed=${data.only_programmed}&user_id=${data.user_id}`)
        .then(response => ([
          {
            text: `Grupos (${response.data.reduce((before, after) => before + parseInt(after.quantity, 10), 0)})`,
            value: '',
          },
          ...response.data.map(item => ({
            value: item.queue,
            ...item.queue === 'normal' && {
              text: `Normal (${item.quantity})`,
            },
            ...item.queue === 'delivered' && {
              text: `Entregado - BOT (${item.quantity})`,
            },
            ...item.queue === 'no_commitment' && {
              text: `Sin compromiso - BOT (${item.quantity})`,
            },
            ...item.queue === 'wrong_person' && {
              text: `Equivocado - BOT (${item.quantity})`,
            },
            ...item.queue === 'refused' && {
              text: `Rechazado - BOT (${item.quantity})`,
            },
          })),
        ])).catch(() => {});
    },
    statusExclude(statusExclude = []) {
      let compare = [];
      if (typeof (statusExclude) !== 'object') {
        compare = [statusExclude];
      } else {
        compare = [...statusExclude];
      }
      return _.filter(this.statuses, x => !compare.includes(x.value));
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/callList.js